import { useEffect } from 'react';

/**
 * Legacy React admin (/admin in CRA) is replaced by Symfony EasyAdmin.
 * REACT_APP_SYMFONY_PUBLIC_URL — публичный URL FrankenPHP (браузер), не прокси CRA.
 */
function getSymfonyAdminUrl() {
  const fromEnv = process.env.REACT_APP_SYMFONY_PUBLIC_URL || process.env.REACT_APP_API_URL;
  if (fromEnv) {
    return `${fromEnv.replace(/\/$/, '')}/admin`;
  }
  return `${window.location.origin}/admin`;
}

export default function AdminRedirect() {
  useEffect(() => {
    window.location.replace(getSymfonyAdminUrl());
  }, []);

  return (
    <div style={{ padding: '2rem', textAlign: 'center' }}>
      Переход в админку…
    </div>
  );
}
